import React, { Fragment } from 'react'
import { FaRegUser } from 'react-icons/fa'

const DefaultAvatar = ({ image, className }) => {
    return (
        <Fragment>
            {image ?
                <img
                    className={`justify-start rounded-full bg-light w-7 h-7 ${className}`}
                    src={image}
                    alt="avatar"
                />
                :

                <FaRegUser />
            }
        </Fragment>
    )
}

export const DefaultImageView = ({ image, name, bg='bg-light' }) => {
    
    const getInitials = (name) => {
        if (!name) return 'NA'; // Default initials if name is unavailable
        const parts = name.split(' ');
        return parts.length > 1
            ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
            : name.substring(0, 2).toUpperCase();
    };

    return (
        <div className={`flex items-center justify-center rounded-md ${bg} w-10 h-10`}>
            {image ?
                <img
                    className={`w-full h-full rounded-full`}
                    src={image}
                    alt="avatar"
                />
                :
                !name ? <FaRegUser /> :
                    <span title={name} className='text-textLight'>{getInitials(name)}</span>
            }
        </div>
    )
}

export const ProfileView = ({ name, image, additionalInfo = [], classnames }) => {
    return (
        <div className={`flex items-center gap-2 ${classnames}`}>
            <div className='flex items-center justify-center rounded-md bg-light w-8 h-8'>
                {image ?
                    <img
                        className={`w-full h-full`}
                        src={image}
                        alt="avatar"
                    />
                    :
                    <FaRegUser />
                }
            </div>
            <div className="flex flex-col">
                <span className="font-medium">{name || '-'}</span>
                <span className="text-[12px] text-textLight leading-3">
                    {additionalInfo.length > 0 ? additionalInfo.join(' | ') : '-'}
                </span>
            </div>
        </div>
    );
};

export default DefaultAvatar
